import type { EFakturaCreditor } from '../../../generated-types';

export type AmountSelectedType = 'all' | 'some';

type EfakturaSharingState = {
    name?: string;
    ssn?: string;
    amountSelected?: AmountSelectedType;
    selected: EFakturaCreditor[] | undefined;
};

export const initialEfakturaSharingState: EfakturaSharingState = {
    name: undefined,
    ssn: undefined,
    selected: undefined,
    amountSelected: undefined,
};

export default EfakturaSharingState;
